/**
 * 优惠券管理
 */

import { PageContext, _, dateUtil } from '@zto/zpage'
import {
  refundDialog, getRefundDetailHandle, getRefundImgInfo, rejectRefundDialog, getMoreLogistics
} from './_actions'
import { formatPrice } from '@/utils/math'
// import { ZdsRefundStatus, ZdsRefundStatusOptions, ZdsRefundTabStatus } from '@/pages/dms/zds/refund/config'
import {ZdsOrderStatus} from "@/pages/orderlist/config";
import {ZdsRefundStatus, ZdsRefundTabStatus} from "@/pages/refund/config";
import dayjs from "dayjs";

export default function (queryType = ZdsRefundTabStatus.ALL){
  return {
    // body: {
      type: 'crud',

      actions: {
        query: { api: '/admin/refundOrder/queryRefundOrderListPage', apiParams:{tabType:queryType } },

        resolve: {
          ...refundDialog()
        },
        detail:{
          ...getRefundDetailHandle()
        },
        reject: {
          ...rejectRefundDialog()
          // api: 'tuxi.zds.order.pc.returnOrderAction',
          // payload: { soNo: '${data.row.soNo}', roNo: '${data.row.roNo}', action:'N' },
          // message: '是否拒绝？'
        },

        moreLogistics:{
          ...getMoreLogistics()
        }
      },

      search: {
        labelWidth: 100,
        span: 6,
        // afterSearch: async ({ app }: PageContext, mapListRes: any) => {
        //   return {
        //     total: 1000000,
        //     data:mapListRes
        //   }
        // },
        items: [
          { label: '订单编号', type: 'input', prop: 'orderId', span: 6 },
          { label: '退款方式',
            type: 'select',
            prop: 'refundType',
            options: [
              { label:'退货退款',value:2},
              { label:'仅退款',value:1}
            ]
          },
          {
            label: '退款原因',
            type: 'select',
            prop: 'refundReason',
            options: [
              { label:'选错商品',value:'WRONG_ITEM' },
              { label:'质量问题',value:'QUALITY_ISSUE' },
              { label:'协商一致退款',value:'AGREED_REFUND' },
              { label:'外观/型号/参数等描述不符',value:'DESCRIPTION_MISMATCH' },
              { label:'商品破损/污染',value:'DAMAGED_POLLUTED' },
              { label:'假冒品牌',value:'COUNTERFEIT' },
              { label:'其他',value:'OTHER' },

            ],
            // default: 'WECHAT'
          },
          {
            label: '退款申请时间',
            labelWidth: 100,
            type: 'date-range-picker',
            prop: 'startApplyTime',
            toProp: 'endApplyTime',
            // span: 8
          }
        ]
      },

      toolbar: {
        items: []
      },


      table: ({app}: PageContext) => ({
        innerAttrs: {
          paginationLayout: 'sizes,prev,next,->,total',
          operationPosition: 'right',
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
          rowKey: 'id'
        },
        operation: {
          width: 150,
          items: [

            {
              action: 'detail',
              label: '查看详情',
            },
            {
              action: 'resolve',
              label: '通过',
              visibleOn: ({ data }: PageContext) => {
                return [ZdsRefundStatus.PENDING_FIRST_AUDIT,ZdsRefundStatus.PENDING_SELLER].includes(data.row.refundStatus);
              },
            },
            {
              action: 'reject',
              label: '驳回',
              visibleOn: ({ data }: PageContext) => {
                return [ZdsRefundStatus.PENDING_FIRST_AUDIT,ZdsRefundStatus.PENDING_SELLER].includes(data.row.refundStatus);
              },
            }

          ]
        },

        columns: [
          { label: '订单编号', prop: 'orderId', width: 200 },
          { label: '购买件数', prop: 'totalQuantity', width: 100 },
          { label: '实付金额', prop: 'actualAmount',
            // formatter:(data: any) => {
            //   return formatPrice(data.actualAmount)
            // },
            width: 100
          },
          { label: '退款方式', prop: 'refundTypeDesc',
            width: 100
          },
          // {
          //   label: '生效状态',
          //   prop: 'popStatus',
          //   formatter: { name: 'enumStr', options: 'txshMpPopupStatus' },
          //   width: 100
          // }
          { label: '退款件数', prop: 'totalQuantity', width: 100 },
          { label: '退款金额', prop: 'actualAmount',

            width: 100 },
          { label: '退货单状态',
            prop:'refundStatusDesc',

            width: 100
          },
          { label: '退款金额是否修改', default: 'returnModifyFlag', width: 100 },
          { label: '退款原因', prop: 'refundReasonDesc', width: 200,
          },
          { label: '申请时间', prop: 'applyTime', width: 150,
            formatter:(data: any)=> {
              const date = dayjs(data.applyTime)
              return date.format('YYYY-MM-DD HH:mm:ss')
            }
          },
          { label: '是否已发货',
            formatter:(data: any) => {
              return data.isShipped ? '是' : '否'
            },
            width: 100
          },
          { label: '发货时间', prop: 'shipmentTime', width: 150,
            formatter:(data: any)=> {
             if (!data.shipmentTime) {
               return "--"
             }
              const date = dayjs(data.shipmentTime)
              return date.format('YYYY-MM-DD HH:mm:ss')
            }},
          { label: '是否已签收',
            formatter:(data: any) => {
              return data.isReceived  ? '是' : '否'
            },
            width: 100 },
          { label: '是否已寄回',
            formatter:(data: any) => {
              return data.isReturned ? '是' : '否'
            },
            width: 100
          },
          { label: '寄回单号/公司', prop: 'returnLogisticsCode', width: 200,
            formatter:(data: any) => {
              return `${data.returnLogisticsNo}/${data.returnLogisticsCompanyName}`
            }},
          { label: '退款备注', prop: 'refundRemark', width: 200 },
          {
            label: '补充材料',
            prop: 'materialList',
            width: 100,
            // disabledOn: '!this.data.soNo',
            action: {
              // disabledOn: '!this.data.row.soNo',
              ...getRefundImgInfo()
            },
            // disabledOn: ({ data }: PageContext) => {
            //   return data.row.soNo
            // },
          }
        ]
      }),

    }
  // }
}
